import {Box} from '@mui/material';
import PropTypes from 'prop-types';
import FormBuilder from './FormBuilder/FormBuilder';

const FormStructure = (props) => {
    const {
        schema,
        templateId,
        accessLevel,
        onSchemaChange,
        isFormArchived,
        isCommunication,
        formId,
        isWizardMode,
        componentToEditIndex,
        setComponentToEditIndex,
        onSchemaValidationChange,
        audience,
        parentAudienceType,
        recipientType,
        linkedToStudents,
        linkedToEmployees,
        triggerSourceAudience,
        scrollContainerRef,
        onScrollContainerScroll,
    } = props;

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    overflow: 'hidden',
                }}
            >

                {schema && (
                    <Box
                        ref={scrollContainerRef}
                        onScroll={onScrollContainerScroll}
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            minHeight: '100vh'
                        }}
                    >
                        <FormBuilder
                            schema={schema}
                            schemaId={templateId}
                            onSchemaChange={onSchemaChange}
                            onSchemaValidationChange={onSchemaValidationChange}
                            isFormArchived={isFormArchived}
                            isCommunication={isCommunication}
                            accessLevel={accessLevel}
                            formId={formId}
                            isWizardMode={isWizardMode}
                            componentToEditIndex={componentToEditIndex}
                            setComponentToEditIndex={setComponentToEditIndex}
                            audience={audience}
                            parentAudienceType={parentAudienceType}
                            recipientType={recipientType}
                            linkedToStudents={linkedToStudents}
                            linkedToEmployees={linkedToEmployees}
                            triggerSourceAudience={triggerSourceAudience}
                        />
                    </Box>
                )}
            </Box>
        </>
    );
};

FormStructure.propTypes = {
    accessLevel: PropTypes.number,
    onNameChange: PropTypes.func,
    schema: PropTypes.array,
    formRef: PropTypes.object,
    name: PropTypes.string,
    templates: PropTypes.array,
    handleTemplateChange: PropTypes.func,
    onSchemaChange: PropTypes.func,
    templateId: PropTypes.number,
    editMode: PropTypes.bool,
    isFormArchived: PropTypes.bool,
    expirationDate: PropTypes.string,
    remindInterval: PropTypes.number,
    onRemindIntervalChange: PropTypes.func,
    onExpirationDateChange: PropTypes.func,
    formId: PropTypes.number,
    formCategories: PropTypes.array,
    categories: PropTypes.array,
    onCategoriesChange: PropTypes.func,
    componentToEditIndex: PropTypes.number,
    setComponentToEditIndex: PropTypes.func,
    onSchemaValidationChange: PropTypes.func,
    isWizardMode: PropTypes.bool,
    audience: PropTypes.number,
    parentAudienceType: PropTypes.number,
    recipientType: PropTypes.string,
    linkedToStudents: PropTypes.bool,
    linkedToEmployees: PropTypes.bool,
    triggerSourceAudience: PropTypes.number,
    wizard: PropTypes.object,
    isCommunication: PropTypes.bool,
    scrollContainerRef: PropTypes.object,
    onScrollContainerScroll: PropTypes.func,
};

export default FormStructure;
